const redirectToPage = (pageURL: string, ...parameters: string[]) => {
  const BASE_URL = window.location.origin;
  window.open(`${BASE_URL}/${pageURL}`, ...parameters);
};

export default redirectToPage;
